










































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as _ from "lodash";
import {
  CdrGailan,
  CdrJigouYuecaiji,
  CdrJigouLiangbiao,
  CdrBingliliangbiao,
} from "@/request/kanban";
import TimeSelect from "../time-type-select.vue";
@Component({
  components: {
    TimeSelect,
  },
})
export default class KanbanCdrGailan extends Vue {
  @Prop()
  private selectedHospitals: any;
  @Prop()
  private center: any;
  private message: any = {
    平台概览: {},
    机构月服务趋势图: {},
    各机构量表采集数分布状况: {
      柱状图: {
        data: [],
      },
      饼图: {
        data: [],
      },
    },
    各病历量表采集状况统计: {
      柱状图: {
        data: [],
      },
      饼图: {
        data: [],
      },
    },
  };
  private cYear: number = new Date().getFullYear();
  private timeType: any = {
    各机构量表采集数分布状况: "全部时间",
    各病历量表采集状况统计: "全部时间",
  };
  private customTime: any = {
    各机构量表采集数分布状况: [],
    各病历量表采集状况统计: [],
  };
  private loaded: boolean = false;
  private colors: any = [
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
    "#FFA7CC",
    "#46AAAA",
    "#FFAA6A",
    "#A185D3",
    "#82D1F1",
    "#EC7E68",
    "#F6C63C",
    "#7784A2",
    "#75DDB5",
    "#759FFC",
  ];
  private pieColors: any = [
    "#50A7F9",
    "#69D688",
    "#FEDB57",
    "#BA95F8",
    "#F4AF6E",
    "#F88AA9",
  ];
  private yuequshi: any = {
    tooltip: {
      show: true,
      trigger: "item",
    },
    grid: {
      left: "5%",
      right: "2%",
      top: "40",
      bottom: "40",
    },
    xAxis: {
      type: "category",
      axisLabel: {
        color: "rgba(0,0,0,0.45)",
      },
      axisLine: {
        lineStyle: {
          color: "rgba(0,0,0,0.45)",
        },
      },
    },
    yAxis: {
      type: "value",
      axisLine: {
        show: false,
      },
    },
    series: [
      {
        type: "bar",
        data: [],
        itemStyle: {
          color: "#6C99F6",
        },
      },
    ],
  };
  private jigouLiangbiaoBingtu: any = {
    grid: {},
    tooltip: {},
    color: this.colors,
    series: [
      {
        type: "pie",
        data: [],
        radius: ["50%", "70%"],
      },
    ],
  };
  private bingliLiangbiaoBingtu: any = {
    grid: {},
    tooltip: {},
    color: this.colors,
    series: [
      {
        type: "pie",
        data: [],
        radius: ["50%", "70%"],
      },
    ],
  };
  private get years() {
    const arr: any = [];
    const currentYear = new Date().getFullYear();
    Array.of(0, 1, 2, 3, 4).forEach((i: any) => {
      arr.push(currentYear - i);
    });
    return arr;
  }
  /**
   * @description 获取平台概览
   */
  private gailan() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      project_id: this.center.project_id,
    };
    CdrGailan(this, params).then((data: any) => {
      console.log(data);
      this.message["平台概览"] = data;
    });
  }
  /**
   * @description 获取机构量表月采集趋势图
   */
  private jigouliangYuecaiji() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      project_id: this.center.project_id,
      year: this.cYear,
    };
    CdrJigouYuecaiji(this, params).then((data: any) => {
      this.message["机构量表月采集趋势图"] = data;
      this.createYuequshi();
    });
  }
  /**
   * @description 月趋势年份改变
   */
  private yueYearChange(year) {
    this.cYear = year;
    this.jigouliangYuecaiji();
  }
  /**
   * @description 创建月采集趋势图
   */
  private createYuequshi() {
    this.yuequshi.series[0].data = this.message["机构量表月采集趋势图"]["data"];
    this.yuequshi.xAxis.data = this.message["机构量表月采集趋势图"]["title"];
  }
  /**
   * @description 获取各机构量表采集数分布状况
   */
  private jigouliangfenbu() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      project_id: this.center.project_id,
    };
    if (this.timeType["各机构量表采集数分布状况"] !== "自定义") {
      params["统计时间"] = this.timeType["各机构量表采集数分布状况"];
    } else {
      params["开始时间"] = this.customTime["各机构量表采集数分布状况"][0];
      params["结束时间"] = this.customTime["各机构量表采集数分布状况"][1];
    }
    CdrJigouLiangbiao(this, params).then((data: any) => {
      console.log(data);
      this.message["各机构量表采集数分布状况"]["柱状图"] = data["data"];
      this.message["各机构量表采集数分布状况"]["饼图"] = data;
      this.createJigouliangbiaofenbu();
    });
  }
  /**
   * @description 创建各机构量表采集数饼图
   */
  private createJigouliangbiaofenbu() {
    this.message["各机构量表采集数分布状况"]["饼图"]["data"].map(
      (item: any) => {
        item.name = item.title;
      }
    );
    this.jigouLiangbiaoBingtu.series[0].data = this.message[
      "各机构量表采集数分布状况"
    ]["饼图"]["data"];
  }
  /**
   * @description 机构量表采集量分布时间改变
   */
  private jigouliangbiaoChange(type) {
    this.timeType["各机构量表采集数分布状况"] = type;
    this.jigouliangfenbu();
  }
  /**
   * @description 机构量表采集量时间自定义改变
   */
  private jigouliangbiaoCustomTimeChange(val) {
    this.customTime["各机构量表采集数分布状况"] = val;
    this.jigouliangfenbu();
  }
  /**
   * @description 获取各病历量表采集数分布状况
   */
  private bingliliangbiaofenbu() {
    const ids: any = [];
    this.selectedHospitals.forEach((h: any) => {
      ids.push(h.hospital_id);
    });
    const params: any = {
      hospital_ids: ids,
      project_id: this.center.project_id,
    };
    if (this.timeType["各病历量表采集状况统计"] !== "自定义") {
      params["统计时间"] = this.timeType["各病历量表采集状况统计"];
    } else {
      params["开始时间"] = this.customTime["各病历量表采集状况统计"][0];
      params["结束时间"] = this.customTime["各病历量表采集状况统计"][1];
    }
    CdrBingliliangbiao(this, params).then((data: any) => {
      console.log(data);
      this.message["各病历量表采集状况统计"]["柱状图"] = data["data"];
      this.message["各病历量表采集状况统计"]["饼图"] = data;
      this.createBingliliangbiaofenbu();
    });
  }
  /**
   * @description 创建各病历量表采集数饼图
   */
  private createBingliliangbiaofenbu() {
    this.message["各病历量表采集状况统计"]["饼图"]["data"].map((item: any) => {
      item.name = item.title;
    });
    this.bingliLiangbiaoBingtu.series[0].data = this.message[
      "各病历量表采集状况统计"
    ]["饼图"]["data"];
  }
  /**
   * @description 各病历量表采集数分布时间改变
   */
  private bingliliangbiaoChange(type) {
    this.timeType["各病历量表采集状况统计"] = type;
    this.bingliliangbiaofenbu();
  }
  /**
   * @description 各病历量表采集数时间自定义改变
   */
  private bingliliangbiaoCustomTimeChange(val) {
    this.customTime["各病历量表采集状况统计"] = val;
    this.bingliliangbiaofenbu();
  }
  /**
   * @description 计算机构量表采集量分布的背景
   */
  private calBackground(index, item) {
    if (!this.$refs.zongliang) {
      return {};
    }
    const style: any = {};
    style.backgroundColor = this.colors[index];
    if (!style.backgroundColor) {
      style.backgroundColor = "#000000";
    }
    style.width =
      item.ratio * 0.8 * (this.$refs.zongliang as any).offsetWidth + 40 + "px";
    return style;
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.$watch(
      () => {
        return this.selectedHospitals;
      },
      () => {
        this.gailan();
        this.jigouliangYuecaiji();
        this.jigouliangfenbu();
        this.bingliliangbiaofenbu();
      },
      {
        immediate: true,
      }
    );
  }
}
